import {CATEGORIES} from './../constants/globalConstants';

const rootGetters = {
  getCurrentCategory: state => {
    return state.currentCategory;
  },
  getCurrentCategoryColor: state => {
    if (state.currentCategory) {
      return CATEGORIES[state.currentCategory].COLOR;
    } else {
      return '';
    }
  },
};

export default rootGetters;
